/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImpressionsCacheInMemory = function () {
  function ImpressionsCacheInMemory() {
    (0, _classCallCheck3.default)(this, ImpressionsCacheInMemory);

    this.queue = [];
  }

  /**
   * Get collected data
   */


  (0, _createClass3.default)(ImpressionsCacheInMemory, [{
    key: 'state',
    value: function state() {
      return this.queue;
    }

    /**
     * Store object in sequential order
     */

  }, {
    key: 'track',
    value: function track(data) {
      this.queue.push(data);

      return this;
    }

    /**
     * Recycle the collector queue
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.queue.length = 0;

      return this;
    }

    /**
     * Hook JSON.stringify to expose the state of the counters
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this.queue;
    }

    /**
     * Check if the is data changed from the defaults
     */

  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.queue.length === 0;
    }
  }]);
  return ImpressionsCacheInMemory;
}();

module.exports = ImpressionsCacheInMemory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/ImpressionsCache/InMemory.js
// module id = 721
// module chunks = 10